
import Vue from 'vue'
import axios from 'axios';
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import * as echarts from 'echarts';
import './utils/rem.js'

Vue.config.productionTip = false;
Vue.use(ElementUI);

Vue.prototype.$axios = axios;
Vue.prototype.$http = axios;
Vue.prototype.$echarts = echarts;

router.beforeEach((to, from, next) => {
  const role = to.meta?.role;
  if (role) {
    const adminInfo = JSON.parse(localStorage.getItem("adminInfo"));
    if (adminInfo && role === adminInfo.role) {
      next();
    } else {
      alert("您没有权限查看!");
      next(false); // 阻止跳转
    }
  } else {
    next();
  }
});


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

